import React from "react";
import frameJoin from "../../assets/frameJoin.png";
import { Box, Button, Container, Typography } from "@mui/material";
import star from "../../assets/star.png";

const Community = () => {
  return (
    <Box
      sx={{
        background: `url(${star}), #021B33`,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
        paddingBottom: "2rem",
        pt: 4,
      }}
    >
      <Container>
        <Box
          sx={{
            background: `url(${frameJoin}),#071836`,
            backgroundSize: "100% 100%",
            padding: { md: "3rem 5rem", xs: "2rem 1rem" },
            backgroundRepeat: "no-repeat",
            paddingBottom: "2rem",
            pt: 4,
            textAlign: "center",
          }}
        >
          <Typography
            varaint="h3"
            sx={{
              fontSize: { xs: "25px", md: "37px" },
              fontWeight: "400",
              fontFamily: "Zen Dots",
              color: "white",
              textAlign: "center",
            }}
          >
            Join our Community
          </Typography>
          <Box mt={1}>
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "400",
                fontFamily: "Inter",
                color: "#D9D9D9",
                textAlign: "center",
              }}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Enim sed
              pulvinar nisl amet, viverra nulla ut. Aliquet nunc justo.
            </Typography>
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "400",
                fontFamily: "Inter",
                color: "#D9D9D9",
                textAlign: "center",
              }}
            >
              bibendum nisl varius fringilla odio eu. Ut et, nullam tristique at
              ultrices. Viverra eget ultrices risus risus adipiscing.
            </Typography>
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "400",
                fontFamily: "Inter",
                color: "#D9D9D9",
                textAlign: "center",
              }}
            >
              Integer tempus aliquam vitae urna, ipsum mattis massa adipiscing
              hendrerit quam.
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Button
              sx={{
                my: 4,
                color: "white",
                display: "block",
                background:
                  "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
              }}
            >
              JOIN COMMUNITY
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Community;
